import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { Checkbox } from '~/view/components/Controls/Checkbox/Checkbox';
import { localeStore } from '~/mobx/localesStore';
import Text, { TEXT } from '~/view/components/Text/Text';
import { cashbackStore } from '~/view/screens/MarketingScreen/screens/Cashback/store/cashbackStore';
import { DELIVERY_TYPE } from '~/constants/deliveryTypes';

const CashbackOrderTypes: FC = observer((): JSX.Element => {
  const handleClick = (orderTypeId: string | number) => {
    const newOrderTypes = cashbackStore.cashback.order_types.includes(orderTypeId as DELIVERY_TYPE)
      ? order_types.filter((type) => type !== orderTypeId)
      : [...order_types, orderTypeId as DELIVERY_TYPE];

    cashbackStore.changeCashback({ order_types: newOrderTypes, branches: cashbackStore.cashback.branches });

    if (cashbackStore.validationErrors.orderTypes) {
      cashbackStore.validateOrderTypes();
    }
  };

  const { order_types } = cashbackStore.cashback;
  const isOrderTypedValidationFailed = cashbackStore.validationErrors.orderTypes !== null;

  return (
    <div className="d-flex flex-column mt-4">
      <Text
        text={localeStore.t('cashback_for_order_type_hdr')}
        type={TEXT.BLOCK_HEADER}
        tooltip={{ message: localeStore.t('cashback_for_order_type_header_hint') }}
        required
      />

      <div className="d-flex flex-column mt-4 gap-20">
        <Checkbox
          label={localeStore.t('delivery')}
          name={DELIVERY_TYPE.DELIVERY}
          value={order_types.includes(DELIVERY_TYPE.DELIVERY)}
          error={isOrderTypedValidationFailed}
          onClick={handleClick}
        />
        <Checkbox
          label={localeStore.t('pickup_curbside')}
          name={DELIVERY_TYPE.PICKUP}
          value={order_types.includes(DELIVERY_TYPE.PICKUP)}
          error={isOrderTypedValidationFailed}
          onClick={handleClick}
        />
        <Checkbox
          label={localeStore.t('dine_in')}
          name={DELIVERY_TYPE.DINE_IN}
          value={order_types.includes(DELIVERY_TYPE.DINE_IN)}
          error={isOrderTypedValidationFailed}
          onClick={handleClick}
        />
      </div>
      {isOrderTypedValidationFailed ? <Text type={TEXT.ERROR} text={cashbackStore.validationErrors.orderTypes} /> : null}
    </div>
  );
});

export default CashbackOrderTypes;
